import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VLayout,
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        VDialog,
        {
          attrs: { value: _vm.isOpen, persistent: "", "max-width": "80vw" },
          on: { "click:outside": _vm.closeModal },
        },
        [
          _c(
            VCard,
            { staticClass: "pt-3" },
            [
              _vm.loading || _vm.saving
                ? _c(VProgressLinear, { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                VForm,
                {
                  ref: "form",
                  staticClass: "ma-2",
                  attrs: { disabled: _vm.loading },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(VCardTitle, { staticClass: "header-text pa-0" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.dialogTitle) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(VTextField, {
                    staticClass: "mt-5",
                    attrs: {
                      label: _vm.pricingGroupDescriptionLabel,
                      rules: _vm.rules,
                      disabled: _vm.isEditMode,
                      dense: "",
                    },
                    model: {
                      value: _vm.userDefinedPricingGroupName,
                      callback: function ($$v) {
                        _vm.userDefinedPricingGroupName =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "userDefinedPricingGroupName",
                    },
                  }),
                  _vm._v(" "),
                  _c(VAutocomplete, {
                    staticClass: "mt-2",
                    attrs: {
                      items: _vm.selectedCDTHierarchies,
                      label: _vm.$t("inputs.cdtHierarchies.selectedCDTs"),
                      disabled: _vm.isEditMode,
                      "item-text": "cdtDescription",
                      "item-value": "cdtId",
                      dense: "",
                      "return-object": "",
                      flat: "",
                      "small-chips": "",
                      multiple: "",
                      "deletable-chips": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.selectedCDTHierarchies,
                      callback: function ($$v) {
                        _vm.selectedCDTHierarchies = $$v
                      },
                      expression: "selectedCDTHierarchies",
                    },
                  }),
                  _vm._v(" "),
                  _c(VTextField, {
                    attrs: {
                      label: "Search CDT descriptions",
                      dense: "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { id: "tree-scroll-container" } },
                    [
                      _c(VTreeview, {
                        staticClass: "hierarchy-item mt-2",
                        attrs: {
                          loading: _vm.loading,
                          search: _vm.search,
                          "selection-type": "independent",
                          selectable: "",
                          hoverable: "",
                          dense: "",
                          "open-on-click": "",
                          "return-object": "",
                          "item-key": "cdtId",
                          "item-text": "cdtDescription",
                          items: _vm.CDTHierarchies,
                        },
                        model: {
                          value: _vm.selectedCDTHierarchies,
                          callback: function ($$v) {
                            _vm.selectedCDTHierarchies = $$v
                          },
                          expression: "selectedCDTHierarchies",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VCardActions,
                { staticClass: "btn-group" },
                [
                  !_vm.loading
                    ? _c("div", [
                        _c(
                          "span",
                          { class: { "error--text": _vm.hasNoCDTSelected } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$tc(
                                    "inputs.cdtHierarchies.selectedCDTCount",
                                    _vm.selectedCDTHierarchies.length
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.hasNoCDTSelected
                          ? _c("span", { staticClass: "error--text" }, [
                              _vm._v(
                                "\n            . " +
                                  _vm._s(
                                    _vm.$t("inputs.cdtHierarchies.cdtRequired")
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(VSpacer),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "grid-btn",
                      attrs: {
                        secondary: "",
                        small: "",
                        disabled: _vm.loading || _vm.saving,
                        depressed: "",
                      },
                      on: { click: _vm.closeModal },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("actions.close")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        disabled:
                          _vm.loading ||
                          _vm.saving ||
                          !_vm.valid ||
                          _vm.hasNoCDTSelected ||
                          _vm.isEditMode,
                        small: "",
                        color: "primary",
                        depressed: "",
                        loading: _vm.saving,
                      },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("actions.save")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }